var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"app"}},[_c('role-picker',{attrs:{"game":_vm.game},on:{"update-game":_vm.updateGame}}),_c('word-matrix',{attrs:{"game":_vm.game,"player":_vm.player},on:{"game-over":_vm.endGame}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }